import { ApexOptions } from "apexcharts";

export const monthlyDropdownList = ['Weekly', 'Monthly', 'Yearly'];

export const orderHistoryTable = [
    {
        id: 1,
        name: "Ossim Keter",
        role: "UX Designer",
        orderNumber: "#8653",
        date: "25/1/2024",
        location: "Sydney",
        status: "Pending",
        amount: "$ 5.538",
        color: "primary",
    },
    {
        id: 2,
        name: "Vent Loren",
        role: "Website Design",
        orderNumber: "#6549",
        date: "10/09/2024",
        location: "Mecca",
        status: "Cancel",
        amount: "$ 1.923",
        color: "secondary",
    },
    {
        id: 3,
        name: "Fran Loain",
        role: "Web Research",
        orderNumber: "#3674",
        date: "26/11/2024",
        location: "Kolkata",
        status: "Paid",
        amount: "$ 2.937",
        color: "warning",
    },
    {
        id: 4,
        name: "Lofte Horen",
        role: "Flutter App",
        orderNumber: "#9614",
        date: "22/07/2024",
        location: "Chicago",
        status: "Done",
        amount: "$ 7.938",
        color: "tertiary",
    },
];

export const appointmentTableData = [
    {
        name: "Elle Abeson",
        color: "primary",
        time: "5 Hour",
        date: "10 March",
        status: "Pending",
        statusClass: "online",
        buttonText: "Pending",
    },
    {
        name: "Anna Catmire",
        color: "secondary",
        time: "1 Hour",
        date: "25 May",
        status: "Done",
        statusClass: "busy",
        buttonText: "Done",
    },
    {
        name: "Rachel Gren",
        color: "tertiary",
        time: "5 Day After",
        date: "25 March",
        status: "Pending",
        statusClass: "offline",
        buttonText: "Pending",
    },
    {
        name: "Lara Dason",
        color: "warning",
        time: "Now",
        date: "12 August",
        status: "Cancel",
        statusClass: "online",
        buttonText: "Cancel",
    },
    {
        name: "Lory Fentor",
        color: "success",
        time: "2 Hour",
        date: "06 May",
        status: "Pending",
        statusClass: "offline",
        buttonText: "Pending",
    },
];

export const activityTimelineData = [
    {
        date: "25-11-2024",
        isNew: false,
        title: "New Order $6348",
        description: "Update New Product Pdf And Delivery Product",
    },
    {
        date: "25-11-2024",
        isNew: true,
        title: "Sade just like your product",
    },
    {
        date: "25-11-2024",
        isNew: false,
        title: "Vent Loren just like your product",
        description:
            "Design and style should work making you look good and feel good without a lot of effort.",
    },
    {
        date: "25-11-2024",
        isNew: false,
        title: "Take Our Client Meeting",
        description: "Hosting an effective client meeting.",
    },
];

export const productRevenueTableData = [
    {
        id: 1,
        name: 'Light sensor Lamp',
        date: '25 Aug 2024',
        amount: '$ 5.938',
        percentSold: '50.93%',
        progressBarWidth: '60%',
        imageSrc: '1.png',
        color: 'primary'
    },
    {
        id: 2,
        name: 'Sony Bluetooth',
        date: '10 Mar 2024',
        amount: '$ 5.937',
        percentSold: '25.52%',
        progressBarWidth: '50%',
        imageSrc: '2.png',
        color: 'secondary'
    },
    {
        id: 3,
        name: 'Watch series',
        date: '10 Jun 2024',
        amount: '$ 3.256',
        percentSold: '56.12%',
        progressBarWidth: '50%',
        imageSrc: '3.png',
        color: 'warning'
    },
    {
        id: 4,
        name: 'Macbook Pro',
        date: '21 Oct 2024',
        amount: '$ 6.538',
        percentSold: '23.41%',
        progressBarWidth: '80%',
        imageSrc: '4.png',
        color: 'tertiary'
    },
    {
        id: 5,
        name: 'I phone Pro max',
        date: '10 Nov 2024',
        amount: '$ 1.258',
        percentSold: '14.34%',
        progressBarWidth: '50%',
        imageSrc: '5.png',
        color: 'primary'
    },
];

//charts
export const monthlyOverviewChart: ApexOptions = {
    series: [{
        name: 'Cash Flow',
        data: [-66, 50, 150, 66, 50, 150, -79, -50, -136, -54, -40, -140, 79, 49, -150, -70,
            50, 140, 60, 44, 130, -80, -40,]

    }],
    chart: {
        type: 'bar',
        height: 250,
        offsetX: 0,
        offsetY: 0,
        toolbar: {
            show: false,
        },
    },
    plotOptions: {
        bar: {
            colors: {
                ranges: [
                    {
                        from: -150,
                        to: -81,
                        color: "#6f5a99",
                    },
                    {
                        from: -80,
                        to: -51,
                        color: "#e24175",
                    },
                    {
                        from: -50,
                        to: 0,
                        color: "#1669A3",
                    },
                    {
                        from: 0,
                        to: 50,
                        color: "#1669A3",
                    },
                    {
                        from: 51,
                        to: 80,
                        color: "#e24175",
                    },
                    {
                        from: 81,
                        to: 150,
                        color: "#6f5a99",
                    }
                ]
            },
            columnWidth: '70%',
            borderRadius: 2
        }
    },

    colors: [
        "#6f5a99"
    ],
    dataLabels: {
        enabled: false,
    },
    yaxis: {
        labels: {
            formatter: function (y) {
                return y.toFixed(0) + "%";
            }
        }
    },

    grid: {
        show: true,
        strokeDashArray: 3,
        borderColor: "rgba(106, 113, 133, 0.30)",
    },
    xaxis: {
        categories: [
            'Jan', '', 'Feb', '', 'Mar', '',
            'Apr', '', 'May', '',
            'Jun', '', 'Jul', '', 'Aug',
            '', 'Sep', '', 'Oct', '', 'Nov',
            '', 'Dec',
        ],
        labels: {
            rotate: -90,
            style: {
                colors: "#9B9B9B",
            },

        },
        axisBorder: {
            offsetX: 0,
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    responsive: [
        {
            breakpoint: 1600,
            options: {
                xaxis: {
                    categories: [
                        'Jan', '', 'Feb', '', 'Mar', '',
                        'Apr', '', 'May', '',
                        'Jun', '', 'Jul', '', 'Aug',
                        '', 'Sep',
                    ],
                },
                series: [{
                    data: [-66, 50, 150, 66, 50, 150, -79, -50, -136, -54, -40, -140, 79, 49, -30, 50, 30]
                }],
            },
        },
        {
            breakpoint: 380,
            options: {
                yaxis: {
                    labels: {
                        show: false,
                    },
                },
            },
        },
    ],
};

export const studyStatisticsChart: ApexOptions = {
    series: [
        {
            name: 'series1',
            data: [2.8, 3.2, 1.9, 4.5, 2.1, 3.7, 3, 3, 4.2, 1.8, 3.9, 2.6],
        },
        {
            name: 'series2',
            data: [1.2, 2, 2.7, 3, 2.5, 3, 1.6, 3.9, 2.5, 2.2, 2.4, 3.2],
        },
    ],
    chart: {
        height: 320,
        type: 'area',
        offsetY: 12,
        offsetX: -10,
        toolbar: {
            show: false,
        },
    },
    dataLabels: {
        enabled: false,
    },
    colors: ['#6f5a99', '#e24175'],

    stroke: {
        curve: 'smooth',
        width: 2,
    },
    grid: {
        show: true,
        strokeDashArray: 5,
        position: 'back',
        xaxis: {
            lines: {
                show: false
            }
        },
    },
    fill: {
        type: 'gradient',
        gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [5, 100, 100, 100]
        },
    },
    annotations: {
        xaxis: [{
            x: 312,
            strokeDashArray: 5,
            borderWidth: 3,
            borderColor: '#6f5a99',
        },
        ],
        points: [{
            x: 312,
            y: 4.5,
            marker: {
                size: 8,
                fillColor: '#6f5a99',
                strokeColor: "#ffffff",
                strokeWidth: 4,
            },
            label: {
                borderWidth: 1,
                offsetY: 0,
                text: '5h a day on average',
                style: {
                    fontSize: '14px',
                    fontWeight: '600',
                    fontFamily: "'Jost', sans-serif",
                }
            }
        }],
    },
    yaxis: {
        labels: {
            show: true,
            style: {
                fontFamily: "'Jost', sans-serif",
                fontWeight: 500,
                colors: '#3D434A',
            },

            formatter: (value) => {
                return `${value}h`;
            },
        },
    },
    xaxis: {
        type: 'category',
        categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ],
        tickAmount: 12,
        labels: {
            minHeight: undefined,
            maxHeight: 28,
            offsetY: 0,
            style: {
                fontFamily: "'Jost', sans-serif",
                fontWeight: 500,
                colors: '#8D8D8D',
            },
        },
        axisBorder: {
            show: false
        },
    },
    tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            return `<div class="apex-tooltip"> 
                  <span>
                       <span class="bg-secondary"> </span>
                        Selling : ${series[0][dataPointIndex]} K
                  </span> 
                  <span class="mt-2">
                       <span class="bg-primary"> </span>
                        Selling : ${series[1][dataPointIndex]} K
                  </span> 
                </div>`;
        },
    },
    legend: {
        show: false,
    },
    responsive: [
        {
            breakpoint: 1661,
            options: {
                chart: {
                    height: 290,
                },
            },
        },
        {
            breakpoint: 1200,
            options: {
                chart: {
                    height: 220,
                },
            },
        },
    ],
};

export const sellViewChart: ApexOptions = {
    series: [
        {
            name: "Selling",
            data: [50, 70, 50, 65, 50, 45, 55, 60],
        },
        {
            name: "Selling",
            data: [-60, -65, -45, -40, -50, -55, -35, -50],
        },
    ],
    chart: {
        type: "bar",
        height: 330,
        stacked: true,
        toolbar: {
            show: false,
        },
    },
    colors: ['#6f5a99', '#e24175'],
    plotOptions: {
        bar: {
            horizontal: true,
            barHeight: "35%",
        },
    },
    dataLabels: {
        enabled: false,
    },
    legend: {
        show: false,
    },
    stroke: {
        curve: "smooth",
    },
    grid: {
        show: true,
        borderColor: "#f0f0f0",
        xaxis: {
            lines: {
                show: true,
            },
        },
        yaxis: {
            lines: {
                show: false,
            },
        },
    },
    yaxis: {
        labels: {
            show: false,
        },
    },
    xaxis: {
        min: -99,
        max: 99,
        tickAmount: 8,
        labels: {
            formatter: function (val: string) {
                return Math.abs(Math.round(Number(val))) + "k";
            },
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    responsive: [
        {
            breakpoint: 768,
            options: {
                chart: {
                    height: 220,
                },
            },
        },
    ],
};

export const beyoLineChart: ApexOptions = {
    series: [
        {
            name: "Net Profit",
            data: [30, 70, 40, 50, 70, 50, 90, 80],
        },
        {
            name: "Free Cash Flow",
            data: [40, 60, 35, 90, 60, 60, 60, 50],
        },
    ],
    chart: {
        type: "bar",
        height: 280,
        offsetY: 5,
        toolbar: {
            show: false,
        },
    },
    plotOptions: {
        bar: {
            horizontal: false,
            borderRadius: 6,
            columnWidth: "18px",
        },
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
    },

    grid: {
        show: false,
        xaxis: {
            lines: {
                show: true,
            },
        },
        yaxis: {
            lines: {
                show: false,
            },
        },
    },
    yaxis: {
        show: false,
        labels: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    xaxis: {
        labels: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    states: {
        hover: {
            filter: {
                type: "darken",
            },
        },
    },
    tooltip: {
        marker: {
            show: false,
        },
        fixed: {
            enabled: false,
            position: "bottomRight",
            offsetX: 0,
            offsetY: 0,
        },
    },
    fill: {
        opacity: 1,
    },
    legend: {
        show: false,
    },
    colors: ['#e24175', '#6f5a99'],
};